import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';

/** Path do hub tenant (`/dashboard` ou `/dashboard/:empresaId`). */
export function tenantHomePath(empresaId?: string | null): string {
  return empresaId ? `/dashboard/${empresaId}` : '/dashboard';
}

/**
 * Resolve `empresaId` ativo (URL > JWT do tenant) e o path correto do TenantHome.
 * Usar em botões "Início" / "Voltar" em qualquer tela do painel do restaurante.
 */
export function useTenantHomePath() {
  const { empresaId: empresaIdParam } = useParams<{ empresaId?: string }>();
  const { role, empresaId: empresaIdJwt } = useAuth();

  return useMemo(() => {
    const empresaIdAtivo =
      empresaIdParam ??
      (role === 'tenant' ? (empresaIdJwt ?? undefined) : undefined);

    return {
      empresaIdAtivo,
      path: tenantHomePath(empresaIdAtivo),
    };
  }, [empresaIdParam, role, empresaIdJwt]);
}
